function mapToParentSection(data) {
  return {
    hasProvincialHealthCoverage: data.hasProvincialHealthCoverage,
    provincialHealthProvince: data.provincialHealthProvince || '',
    hasOtherInsuranceCoverage: data.hasOtherInsuranceCoverage,
    otherInsuranceCoverageTypes: data.otherInsuranceCoverageTypes || [],
    IsGHIP: data.hasProvincialHealthCoverage || false,
    Recovery: data.hasOtherInsuranceCoverage || false,
  };
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepOtherInsuranceCoverageTugoDataMapper.js